import { useEffect } from "react";
import { useTheme } from "@/context/ThemeContext";
import { loadRefTagger, updateRefTaggerTheme, retag } from "@/lib/reftagger";

export function RefTaggerLoader() {
  const { theme } = useTheme();
  useEffect(() => {
    loadRefTagger(theme);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- intentional: load the RefTagger script once; theme changes are handled separately
  useEffect(() => {
    updateRefTaggerTheme(theme);
  }, [theme]);
  return null;
}

export function useRefTagger(deps = []) {
  useEffect(() => {
    retag();
    const t = setTimeout(retag, 400);
    return () => clearTimeout(t);
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps -- intentional: caller supplies the re-tag triggers
}
